// Mock data for Coin Bills landing page

export const heroData = {
  tagline: "Non-Custodial Crypto & Gold Asset Management",
  headline: "Redefining the Future of Digital Asset Management",
  subtext: "Professional trading across crypto and gold markets through secure, API-based automation. Your assets always remain in your own exchange wallet.",
  ctaPrimary: "Get Started",
  ctaSecondary: "Learn More"
};

export const aboutData = {
  sectionLabel: "[ ABOUT US ]",
  title: "Redefining the Future of Digital Asset Management",
  intro: "Coin Bills is a digital asset management platform built for investors who value control, transparency, and disciplined execution.",
  description: "We enable clients to participate in professional crypto and gold trading through secure, API-based automation, while ensuring that all assets remain in the client's own exchange wallet at all times. Coin Bills does not accept or hold client funds.",
  brokerInfo: "Coin Bills operates as a broker under the Bybit Broker Program and also integrates with multiple leading crypto exchanges and execution venues. This multi-exchange approach allows us to diversify execution, manage liquidity, and reduce platform-specific risk.",
  nonCustodial: {
    title: "Non-Custodial at the Core",
    subtitle: "Coin Bills is built on a strict non-custodial architecture.",
    points: [
      "Client assets are never transferred, pooled, or stored with us.",
      "All trading is executed directly on the client's exchange account using trade-only API permissions, with withdrawals permanently disabled.",
      "Clients retain full control and can pause, disconnect, or withdraw at any time."
    ]
  },
  execution: {
    title: "Built for Disciplined, Long-Term Execution",
    description: "Markets change, volatility shifts, and emotions often influence decisions. Our focus is on structured processes, risk management, and consistency rather than short-term speculation.",
    note: "By combining automation with clearly defined rules, we aim to deliver repeatable and responsible execution across market conditions."
  },
  vision: {
    title: "Our Vision",
    description: "To build a trusted, multi-exchange digital asset management platform where investors can grow responsibly — without giving up custody or control of their assets."
  }
};

export const approachData = {
  sectionLabel: "[ OUR APPROACH ]",
  title: "Multi-Exchange. Risk-Aware. Non-Custodial.",
  intro: "Our approach to digital asset management is centered on diversification, automation, and risk control.",
  subtitle: "We believe that sustainable results come from disciplined execution across multiple venues, not reliance on a single exchange or method.",
  pillars: [
    {
      id: 1,
      title: "Non-Custodial by Design",
      description: "Coin Bills does not hold or custody client funds. All assets remain securely within the client's exchange wallet.",
      points: [
        "No withdrawal access",
        "No fund transfers",
        "Full client ownership at all times"
      ]
    },
    {
      id: 2,
      title: "Broker & Multi-Exchange Execution",
      description: "Coin Bills operates as a broker under the Bybit Broker Program and supports trading across multiple exchanges and execution methods.",
      points: [
        "Reduce exchange-specific dependency",
        "Optimize liquidity and execution quality",
        "Adapt strategies to different market environments"
      ]
    },
    {
      id: 3,
      title: "Strategy-Driven Automation",
      description: "All trading activity follows predefined strategies with clear rules for capital allocation, position sizing, entry/exit logic, and risk limits.",
      points: [
        "Consistent execution",
        "Minimized emotional bias",
        "Rule-based decision making"
      ]
    },
    {
      id: 4,
      title: "Risk Management & Diversification",
      description: "Risk management is central to our approach. We actively manage exposure across strategies, allocation across exchanges, and drawdown controls.",
      points: [
        "Exposure management",
        "Volatility controls",
        "Multi-venue diversification"
      ]
    },
    {
      id: 5,
      title: "Transparency & Client Control",
      description: "Clients maintain full visibility and control at all times. Monitor performance, pause strategies, or withdraw funds directly.",
      points: [
        "Real-time monitoring",
        "Instant pause/disconnect",
        "No lock-ins or hidden actions"
      ]
    }
  ],
  philosophy: {
    title: "Our Philosophy",
    points: [
      "Control builds trust.",
      "Diversification reduces risk.",
      "Discipline drives consistency."
    ],
    note: "Coin Bills is designed for investors who value structure, transparency, and responsible execution in digital asset management."
  }
};

export const statsData = [
  {
    id: 1,
    value: "344+",
    label: "Trusted Clients"
  },
  {
    id: 2,
    value: "100%",
    label: "Non-Custodial"
  },
  {
    id: 3,
    value: "Multi",
    label: "Exchange Support"
  },
  {
    id: 4,
    value: "24/7",
    label: "Automated Trading"
  }
];

export const footerData = {
  disclaimer: "Coin Bills is an independent platform operating as a broker under the Bybit Broker Program and integrating with multiple crypto exchanges. Coin Bills does not accept or hold client funds. Coin Bills is not owned, operated, or endorsed by Bybit or any other exchange. Digital asset trading involves risk. Past performance does not guarantee future results.",
  email: "private@coinbills.com"
};

export const navLinks = [
  { label: "ABOUT", href: "#about" },
  { label: "APPROACH", href: "#approach" },
  { label: "CONTACT", href: "#contact" }
];
